import React from 'react'
import { styled } from 'styled-components'

const Dot = styled.div`
  content: '';

  left: 0;
  top: 0;

  width: 4px;
  height: 4px;
  background: grey;
  border-radius: 50%;

  animation: blink 1s infinite;
  animation-fill-mode: both;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes blink {
    0% {
      opacity: 0.1;
    }
    20% {
      opacity: 1;
    }
    100% {
      opacity: 0.1;
    }
  }
`

const Wrapper = styled.div`
  display: flex;
  gap: 2px;
`

type Props = { test?: string }

export const LoaderDots: React.FC<Props> = () => {
  return (
    <Wrapper>
      <Dot />
      <Dot />
      <Dot />
    </Wrapper>
  )
}
